import React from 'react';
import styled from '@emotion/styled';

const Wrapper = styled('tr')`
  height: 68px;

  td {
    padding: 0.85rem;
  }

  .td {
    width: 200px;
  }

  .skelet {
    background-color: #f2f5f7;
    border-radius: 0.25rem;
    -webkit-animation: blinking 1s infinite ease-in-out;
    animation: blinking 1s infinite ease-in-out;
    @media (max-width: 731px) {
      margin-top: 5px;
    }
  }

  .number {
    width: 50px;
    height: 12px;
  }

  .date {
    height: 10px;
    width: 82px;
    margin-top: 8px;
  }

  .title {
    height: 14px;
  }

  .text {
    height: 12px;
    &:nth-child(n + 2) {
      margin-top: 10px;
    }
  }

  .status {
    width: 75px;
  }

  .qty {
    width: 43px;
    text-align: center;
  }

  @media (max-width: 731px) {
    .hide-them {
      width: 23px;
      display: none;
    }
  }
`;

const ItemsSkeleton = () => {
  return (
    <Wrapper>
      <td className="td" align="center">
        <div className="number skelet"></div>
        <div className="date skelet"></div>
      </td>
      <td className="td" align="center">
        <div className="title skelet"></div>
      </td>
      <td className="td hide-them" align="center">
        <div className="text status skelet"></div>
      </td>
      <td className="td hide-them" align="center">
        <div className="text status skelet"></div>
      </td>
      <td className="td hide-them" align="center">
        <div className="text status skelet"></div>
      </td>
      <td className="td hide-them" align="center">
        <div className="text status skelet"></div>
      </td>
      <td className="td hide-them" align="center">
        <div className="text status skelet"></div>
      </td>
      <td className="td hide-them" align="center">
        <div className="text status skelet"></div>
      </td>
      <td className="td hide-them" align="center">
        <div className="text status skelet"></div>
      </td>
      <td className="td hide-them" align="center">
        <div className="text qty skelet"></div>
      </td>
      <td className="td hide-them" align="center">
        <div className="text qty skelet"></div>
      </td>
    </Wrapper>
  );
};

export default ItemsSkeleton;
